import { mockDelay } from '@/apis/mockDelay'
import { IS_MOCK } from '@/constants'
import { Sentry } from '@/lib/sentry'
import type { JackpotWinner } from '@/types/winner'

import { MOCK_JACKPOT_WINNER } from './mocks'
import { explainInvalidJackpotWinner, validateJackpotWinner } from './validateJackpotWinner'

/**
 * 잭팟 당첨자 — 같은 도메인 S3 의 /winner.json (슬랙 명령 → GitHub 워크플로가 올린다).
 * 실패해도 던지지 않는다: 토스트만 안 뜨고 화면은 정상이어야 한다.
 * - 파일 없음: CloudFront 가 403 을 index.html(200)로 돌려주므로 JSON 파싱 실패 → 조용히 null
 * - JSON 인데 형식 오류: 운영 입력 실수 → Sentry warning 으로 알린다
 */
const WINNER_JSON_PATH = '/winner.json'

export const apiGetJackpotWinner = async (): Promise<JackpotWinner | null> => {
  if (IS_MOCK) {
    await mockDelay()
    return MOCK_JACKPOT_WINNER
  }

  let body: unknown
  try {
    const response = await fetch(WINNER_JSON_PATH, { cache: 'no-store' })
    if (!response.ok) return null
    body = await response.json()
  } catch {
    return null
  }

  const winner = validateJackpotWinner(body)
  if (!winner) {
    // 운영 입력 실수 신호. 같은 이슈로 묶이게 메시지는 고정, 원인은 extra 로
    Sentry.captureMessage('winner.json invalid shape', {
      level: 'warning',
      extra: { reason: explainInvalidJackpotWinner(body) },
    })
  }

  return winner
}
